import { VueConstructor } from 'vue';
import { Store } from 'vuex';

import BHFlowHolder from './bh-flow-holder.vue';
import BHFlowItem from './bh-flow-item.vue';
import BHFlowArrow from './bh-flow-arrow.vue';
import BHFlowDroppable from './bh-flow-droppable.vue';
import BHFlowGenerator from './bh-flow-generator.vue';
import BHFlowToolbox from './bh-flow-toolbox.vue';
import BHFlowProperties from './bh-flow-properties.vue';
import BHFlowFieldGenerator from './bh-flow-field-generator.vue';
import BHFlow from './bh-flow.vue';

const ComponentPlugins = {
    install(Vue: VueConstructor) {
        Vue.component('BhFlowHolder', BHFlowHolder);
        Vue.component('BhFlowItem', BHFlowItem);
        Vue.component('BhFlowArrow', BHFlowArrow);
        Vue.component('BhFlowDroppable', BHFlowDroppable);
        Vue.component('BhFlowGenerator', BHFlowGenerator);
        Vue.component('BhFlowToolbox', BHFlowToolbox);
        Vue.component('BhFlowProperties', BHFlowProperties);
        Vue.component('BhFlowFieldGenerator', BHFlowFieldGenerator);
        Vue.component('BhFlow', BHFlow);
    }
};

export function BHFlowStore(store: Store<any>) {
    store.registerModule('bh-flow', {
        namespaced: true,
        state: {
            show: false,
            module: null,
            handler: () => null,
            value: {},
            timestamp: 0,
            child: 0
        },
        getters: {
            
        },
        mutations: {
            setSettings(state, data) {
                state.value = data.props;
                state.module = data.module;
                state.handler = data.handler;
                state.show = true;
                state.timestamp = Math.floor(Date.now() / 1000);
                state.child = data.child;
            },
            hide(state) {
                state.show = false;
            }
        },
        actions: {
            async setSettings(store, data) {
                store.commit('setSettings', data);
            }
        }
    });
}

export default ComponentPlugins;